export class Base{
  constructor(args) {
    this.mixin(args)
  }

  mixin(source) {
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        this[prop] = source[prop];
      }
    }
  }
}
